import InputAndLabel from "./InputAndLabel";
export default InputAndLabel;
